<template>
    <div>
        <v-layout row wrap>
            <v-layout class="pl-9" row wrap v-if="!isOld">
                <confirmation-header-text text="Tourist Visa" class="ml-0"
                                          icon="mdi-alpha-t-box"></confirmation-header-text>
                <v-flex xs3>
                    <list-item-detail :sub_title="purpose_of_visa"
                                      title="Purpose of Visa"/>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="application_data.address_in_nepal"
                                      title="Address in Nepal"/>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="mx-0" v-else>
                <confirmation-header-text text="Tourist Visa" class="ml-0"
                                          icon="mdi-alpha-t-box"></confirmation-header-text>
                <v-flex xs3>
                    <list-item-detail :sub_title="application_data.staying_at"
                                      title="Staying At"/>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="application_data.staying_name"
                                      title="Name of hotel or place"/>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="application_data.staying_address"
                                      title="Hotel address"/>
                </v-flex>
            </v-layout>
        </v-layout>
       <v-layout v-if="accompanied" row wrap class="px-6">
                <v-flex xs12>
                    <h3 style="color: black; font-size: 14px;">Accompanied by</h3>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="accompanied.name"
                                      title="Name"/>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="accompanied.passport_number"
                                      title="Passport number"/>
                </v-flex>
                <v-flex xs3>
                    <list-item-detail :sub_title="accompanied.relation"
                                      title="Relation"/>
                </v-flex>
            </v-layout>
    </div>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";


    export default {
        components: {
            ListItemDetail,ConfirmationHeaderText
        },
        computed: {
            accompanied() {
                if (this.$store.state.VisaRequestSingle.extra !== undefined) {
                    if (this.$store.state.VisaRequestSingle.visaRequest.extra.accompanied.length === 0) {
                        return false;
                    }
                    return this.$store.state.VisaRequestSingle.visaRequest.extra.accompanied;

                }


                return false;
            },
            purpose_of_visa() {
                return this.$store.state.VisaRequestSingle.visaRequest.purpose_of_visa;
            }
            ,
            isOld() {
                return this.$store.state.VisaRequestSingle.visaRequest.old;
            }
            ,
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            }
        }
    }
    ;
</script>

<style>
</style>
